"use client"

import { motion } from "framer-motion"
import { useEffect, useState } from "react"

import { useSearch } from "@/hooks/use-search"

import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui/drawer"

import { Input } from "../ui/input"

export default function OtherFilters() {
  const { filter, search } = useSearch()
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 1024;
  return (
    <>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.2, delay: 0.1 }}
        className="flex w-full flex-col gap-[28px]"
      >
        <OtherFiltersContent />
      </motion.div>
      {isMobile && (
        <Drawer
          onClose={() => {
            search({
              filter: null,
            })
          }}
          dismissible
          open={filter === "Other filters"}
        >
          <DrawerContent>
            <DrawerHeader>
              <DrawerTitle>Other filters</DrawerTitle>
              <DrawerDescription>
                Select more filters to refine your search
              </DrawerDescription>
            </DrawerHeader>
            <div className="mx-auto w-full max-w-[800px] shrink-0 p-4">
              <OtherFiltersContent />
            </div>
          </DrawerContent>
        </Drawer>
      )}
    </>
  )
}

export function OtherFiltersContent() {
  const [minPrice, setMinPrice] = useState<number | undefined>()
  const [maxPrice, setMaxPrice] = useState<number | undefined>()
  const {
    minPrice: searchParamsMinPrice,
    maxPrice: searchParmsMaxPrice,
    search,
  } = useSearch()

  useEffect(() => {
    if (minPrice !== undefined && maxPrice !== undefined) return

    const minPriceTemp = searchParamsMinPrice ?? undefined
    const maxPriceTemp = searchParmsMaxPrice ?? undefined
    if (minPriceTemp !== undefined) {
      setMinPrice(parseInt(minPriceTemp))
    }
    if (maxPriceTemp !== undefined) {
      setMaxPrice(parseInt(maxPriceTemp))
    }
  }, [searchParamsMinPrice, searchParamsMinPrice])

  return (
    <div>
      <div className="flex max-h-[500px] w-full flex-col !gap-[10px] overflow-y-auto pb-10 sm:max-h-full lg:h-full lg:max-h-full">
        <Input
          min={1}
          max={1998}
          type="number"
          label="Minimum price"
          placeholder="Type a number"
          value={minPrice}
          className="w-full"
          onChange={(e) => {
            setMinPrice(parseInt(e.target.value))
            search({
              minPrice: e.target.value ? parseInt(e.target.value) : null,
            })
          }}
        />
        <Input
          min={2}
          max={1999}
          type="number"
          className="w-full"
          label="Maximum price"
          placeholder="Type a number"
          value={maxPrice}
          onChange={(e) => {
            setMaxPrice(parseInt(e.target.value))
            search({
              maxPrice: e.target.value ? parseInt(e.target.value) : null,
            })
          }}
        />
      </div>
    </div>
  )
}
